module.exports = __webpack_public_path__ + "img/twelve.b93fc1dc.png";